import type { IOtherReviewsPopupData } from './models';
import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import PopupOtherReviews from './PopupOtherReviews.vue';

const { createPopup } = usePopups();
const otherReviewsPopup = createPopup({ component: PopupOtherReviews });

export function useOtherReviewPopup() {
  function showOtherReviewPopup(data: IOtherReviewsPopupData) {
    otherReviewsPopup.show(data);
  }

  return { showOtherReviewPopup };
}
